


document.addEventListener('variant:change', function (evt) {
  var variant = evt.detail.variant;
  var target = document.querySelector('[data-variant-description-target]');
  var source = document.querySelector(
    '#variant-descriptions [data-variant-id="' + variant.id + '"]'
  );
  if (target && source && source.innerHTML.trim()) {
    target.innerHTML = source.innerHTML;
  }
});